import create from 'zustand'
import verifyWithGoogle from '../../networks/VerifyWithGoogle';

const verifyWithGoogleStore = create((set, get) => {

  const setErrorAction = (isError, msg) => set({
    hasError: isError,
    errorMessage: msg
  })

  const verifyAction = async (code) => {
    try {
      set({ isLoading: true })
      const response = await verifyWithGoogle(code)
      set({ 
        result: response.data,
        isLoading: false,
      })
    } catch (error) {
      set({ isLoading: false })
      setErrorAction(true, error.response?.data?.message || error.message);
    }
  }

  const clearAllAction = () => set({
    ...initState
  })

  const initState = {
    result: null,
    isLoading: false,
    hasError: false,
    errorMessage: '',
  }
  
  return {
    ...initState,
    setError: setErrorAction,
    verify: verifyAction,
    clearAll: clearAllAction,
  }
});

export default verifyWithGoogleStore;